export default "__VITE_ASSET__CE1Gz3LJ__"